const InstallIcon = ({ width = "16px", height = "16px" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    width={width}
    height={height}
  >
    <g fill="#000">
      <path d="M26 30H6a2 2 0 0 1-2-2V16c0-1.1.9-2 2-2h3v2H6v12h20V16h-3v-2h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2Z" />
      <path d="M19 20h-6v2h6v-2Zm1.6-11.4L17 12.2V2h-2v10.2l-3.6-3.6L10 10l6 6 6-6-1.4-1.4Z" />
    </g>
  </svg>
);

export default InstallIcon;
